module.exports = "/_next/static/images/df192043a072dd28771f085723a34891-boy-looking-to-the-front-md@3x.jpg";